import React, { useContext, Fragment, useState, useEffect } from "react";
import Blue from "../state/themes/Blue";
import Gold from "../state/themes/Gold";
import Classic from "../state/themes/default.json";
import Green from "../state/themes/Green";
import Purple from "../state/themes/Purple";
import UI from "../state/themes/UI.json";
import GITHUB from "../state/themes/github.json";
import JAVASCRIPT from "../state/themes/javascript.json";
import PYTHON from "../state/themes/python.json";
import { Store } from "../state/state";
import Overlay from "./Overlay";
import { useObserver } from "mobx-react";
import { FB, storage } from "../config";
import { set, toJS } from "mobx";
import theme from "../state/themes/Purple";
function ThemePicker() {
  const [open, setOpen] = useState(false);
  const store = useContext(Store);
  const AllTemplete = Overlay(OverlayTheme);
  return (
    <Fragment>
      <div
        className="flex w-full items-center my-4 cursor-pointer"
        onClick={() => setOpen(true)}
      >
        <div className="border flex-1 px-5 py-2 shadow rounded-l-md">
          {store.selectTheme}
        </div>
        <span className="bg-white rounded-r-md px-5 py-2 text-black shadow">
          {" "}
          إختر المظهر
        </span>
      </div>
      <AllTemplete
        title={"المظهر"}
        open={open}
        onClose={() => setOpen(false)}
        style={{ padding: "5% 15%" }}
        fullScreen
        // actionSection={

        // }
      />
    </Fragment>
  );
}
function OverlayTheme({ onClose, open }) {
  const store = useContext(Store);
  const [data, setData] = useState([]);
  const [templetes, setTempletes] = useState([]);
  const getTemplete = async () => {
    // let result = [];
    // let categories = await FB.collection("categories").get();
    // categories.forEach(async (doc) => {
    //   let theme = [];
    //   let themes = await FB.collection("categories")
    //     .doc(doc.id)
    //     .collection("theme")
    //     .get();
    //   themes.forEach((docChild) => {
    //     theme.push(docChild.data());
    //   });
    //   theme = theme.length > 0 ? theme : [];
    //   console.log("add :", { theme, category: doc.data() });
    //   result.push({ theme, category: doc.data() });
    // });
    // console.log("result :", result);
    // setTempletes(result);
  };
  useEffect(() => {
    if (open) getTemplete();
  }, [open]);
  const TMPLETE = [Classic, Blue, Gold, Green, Purple];
  const TMPLETE_UINIVERSITY = [UI];
  const TMPLETE_PROGRAMMER = [PYTHON, GITHUB, JAVASCRIPT];
  const GroupName = ({ children }) => (
    <div className="flex w-full items-center pr-2 pl-5">
      <span className="text-xl ml-5 font-mono font-bold">{children}</span>
      <div
        className="h-1 flex-1 rounded-full bg-gray-900"
        style={{ height: "0.8px" }}
      />
    </div>
  );
  return useObserver(() => (
    <div className="h-full flex flex-col">
      <div className="w-full flex-1    overflow-y-auto ">
        <GroupName>عادي</GroupName>
        <div className="grid grid-cols-4   gap-x-5 gap-y-2 justify-center  px-2 py-5">
          {TMPLETE.map((templete) => (
            <TempletItem
              select={store.selectTheme === templete.id}
              data={templete}
              onSelect={() => {
                store.selectTheme = templete.id;
                store.selectNewTheme = templete;
              }}
            />
          ))}
        </div>
        <GroupName>جامعي</GroupName>
        <div className="grid grid-cols-4   gap-x-5 gap-y-2 justify-center  px-2 py-5">
          {TMPLETE_UINIVERSITY.map((templete) => (
            <TempletItem
              select={store.selectTheme === templete.name}
              data={templete}
              onSelect={() => {
                store.selectTheme = templete.name;
                store.selectNewTheme = templete;
              }}
            />
          ))}
        </div>
        <GroupName>مبرمجين</GroupName>
        <div className="grid grid-cols-4   gap-x-5 gap-y-2 justify-center  px-2 py-5">
          {TMPLETE_PROGRAMMER.map((templete) => (
            <TempletItem
              select={store.selectTheme === templete.name}
              data={templete}
              onSelect={() => {
                store.selectTheme = templete.name;
                store.selectNewTheme = templete;
              }}
            />
          ))}
        </div>
        <GroupName>قطاعات حكومية</GroupName>
        <GroupName>شركات</GroupName>
      </div>
      <div className="flex items-center py-2 w-full shadow-2xl border rounded-lg">
        <div
          className="bg-btnColor text-white rounded shadow px-10 py-2 cursor-pointer mx-2 hover:bg-orange-600"
          onClick={async () => {
            let send = JSON.stringify({
              name: "classic",
              theme: toJS(store.selectNewTheme),
            });

            console.log(send);
            // await FB.database().ref("Theme/Calendar/test").set(send);
            store.setTheme(store.selectNewTheme);
            onClose();
          }}
        >
          موافق
        </div>
        <div
          className=" rounded shadow px-10 py-2 cursor-pointer mx-2 "
          onClick={onClose}
        >
          الغاء
        </div>
        <div className="flex-1"></div>
        <div
          className="bg-btnColor text-white rounded shadow px-10 py-2 cursor-pointer mx-2 hover:bg-orange-600"
          onClick={async () => {
            let send = JSON.stringify({
              name: "classic",
              theme: toJS(store.selectNewTheme),
            });
            const inputFile = document.createElement("input");
            inputFile.type = "file";
            inputFile.accept = ".json";
            inputFile.onchange = (e) => {
              const file = e.target.files[0];
              var reader = new FileReader();
              reader.onload = () => {
                var theme = JSON.parse(reader.result);
                console.log("result :", theme);
                store.setTheme(theme);
              };
              reader.readAsText(file);
            };
            document.body.appendChild(inputFile);

            inputFile.click();
            document.body.removeChild(inputFile);
            console.log(send);
            // await FB.database().ref("Theme/Calendar/test").set(send);
            // store.setTheme(store.selectNewTheme);
            onClose();
          }}
        >
          فتح مظهر من الجهاز
        </div>
        {/* <input
          type="file"
          name=""
          id=""
          accept=".json"
          onChange={(e) => {
            const file = e.target.files[0];
            var reader = new FileReader();
            reader.onload = () => {
              var fileContent = JSON.parse(reader.result);
              console.log("result :", fileContent);
            };
            reader.readAsText(file);
          }}
        /> */}
      </div>
    </div>
  ));
}
const TempletItem = ({ data, onSelect, select }) => (
  <div
    className={
      "  h-40 flex py-2 flex-col justify-between items-center   rounded bg-white cursor-pointer hover:bg-gray-100 " +
      (select && "bg-gray-100 shadow")
    }
    onClick={onSelect}
  >
    <SmallCalendar data={data} />
    <div className="flex items-center">
      <input type="checkbox" name="" id="" checked={select} />
      <span className="w-full text-center mx-2">{data.name}</span>
    </div>
  </div>
);
const SmallCalendar = ({ data }) => (
  <div className="flex w-24 h-24 bg-green-300  flex-col">
    <div
      className="flex-1 "
      style={{ backgroundColor: data.header.backgroundColor }}
    />
    <div className="flex w-full" style={{ flex: 3 }}>
      <div className="flex flex-col  bg-gray-600" style={{ flex: 1 }}>
        <div
          className="h-3 border"
          style={{
            backgroundColor: data.note.header.backgroundColor,
          }}
        ></div>
        <div
          className="flex border"
          style={{ flex: 3, backgroundColor: data.note.body.backgroundColor }}
        ></div>
      </div>
      <div className="flex flex-col " style={{ flex: 2 }}>
        <div
          className="h-3 border"
          style={{ backgroundColor: data.note.header.backgroundColor }}
        ></div>
        <div
          className=" border grid grid-cols-7  "
          style={{
            flex: 3,
            backgroundColor: data.main.blockUnActive.backgroundColor,
          }}
        >
          {[
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            16,
            1,
            2,
            3,
            4,
            6,
            1,
            2,
            3,
            4,
          ].map(() => (
            <BoxCalendar
              color={data.main.blockActive.backgroundColor}
              borderColor={data.main.blockActive.borderColor}
            />
          ))}
          {/* <BoxCalendar color={data.main.blockActive.backgroundColor} />
          <BoxCalendar color={data.main.blockActive.backgroundColor} />
          <BoxCalendar color={data.main.blockActive.backgroundColor} />
          <BoxCalendar color={data.main.blockActive.backgroundColor} />
          <BoxCalendar color={data.main.blockActive.backgroundColor} />
          <BoxCalendar color={data.main.blockActive.backgroundColor} />
          <BoxCalendar color={data.main.blockActive.backgroundColor} />
          <BoxCalendar color={data.main.blockActive.backgroundColor} />
          <BoxCalendar color={data.main.blockActive.backgroundColor} />
          <BoxCalendar color={data.main.blockActive.backgroundColor} />
          <BoxCalendar color={data.main.blockActive.backgroundColor} />
          <BoxCalendar color={data.main.blockActive.backgroundColor} />
          <BoxCalendar color={data.main.blockActive.backgroundColor} />
          <BoxCalendar color={data.main.blockActive.backgroundColor} />
          <BoxCalendar color={data.main.blockActive.backgroundColor} />
          <BoxCalendar color={data.main.blockActive.backgroundColor} /> */}
        </div>
      </div>
    </div>
    {/* <BlockColors color={data.header.backgroundColor} />
    <BlockColors color={data.note.header.backgroundColor} />
    <BlockColors color={data.note.body.backgroundColor} />
    <BlockColors color={data.main.blockActive.backgroundColor} />
    <BlockColors color={data.main.blockUnActive.backgroundColor} /> */}
  </div>
);
const BoxCalendar = ({ color, borderColor }) => (
  <div
    className="border"
    style={{
      borderWidth: "0.2px",
      backgroundColor: color,
      borderColor: borderColor,
    }}
  ></div>
);
export default ThemePicker;
